import type { ViewStyle } from 'react-native';

export const tokens = {
  designVersion: 'v0.7.2',
  colors: {
    background: '#F4EDE3',
    appFrame: '#E7DECF',
    surface: '#FFFFFF',
    surfaceMuted: '#FBF7F1',
    primary: '#C0432F',
    primaryPressed: '#A3361F',
    primarySoft: '#E07856',
    accent: '#E8853F',
    accentSoft: '#FBEADD',
    dusk: '#3D5A80',
    duskSoft: '#E5EBF3',
    summit: '#E0A43B',
    summitSoft: '#F8EDD4',
    text: '#2B2118',
    textMuted: '#6B5D4F',
    textSubtle: '#9C8F80',
    border: '#EBE3D8',
    danger: '#C0432F',
    dangerSoft: '#F6E7E1',
    success: '#2E6A4A',
    successSoft: '#E4EFE7',
    warning: '#E8853F',
    warningSoft: '#FBEADD',
    deepSpace: '#081020',
    deepSpaceAlt: '#0B1224',
    starText: '#F4F8FF',
    starMuted: '#91A4C4',
    starLine: '#375D8F',
    starCyan: '#4FE5FF',
    starViolet: '#8C7CFF',
    starAmber: '#FFB86B',
    starDanger: '#FF6B5D',
    white: '#FFFFFF',
  },
  semantic: {
    page: '#F4EDE3',
    frame: '#E7DECF',
    card: '#FFFFFF',
    cardMuted: '#FBF7F1',
    primaryAction: '#C0432F',
    secondaryAction: '#2E6A4A',
    focusRing: '#E0A43B',
    divider: '#EBE3D8',
    ink: '#2B2118',
    inkMuted: '#6B5D4F',
  },
  state: {
    idle: '#3D5A80',
    uploading: '#C0432F',
    recognizing: '#E8853F',
    matching: '#E0A43B',
    solving: '#2E6A4A',
    lowConfidence: '#E8853F',
    noMatch: '#3D5A80',
    agentTimeout: '#C0432F',
    retrying: '#E0A43B',
    successHandoff: '#2E6A4A',
    failed: '#C0432F',
  },
  fontSize: {
    xs: 11,
    sm: 13,
    md: 15,
    lg: 18,
    xl: 24,
    xxl: 30,
  },
  lineHeight: {
    xs: 16,
    sm: 18,
    md: 22,
    lg: 26,
    xl: 32,
    xxl: 38,
  },
  fontWeight: {
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    xxl: 32,
  },
  radius: {
    sm: 12,
    md: 16,
    lg: 22,
    cardSm: 16,
    cardLg: 28,
    full: 999,
  },
  border: {
    width: 1,
  },
  shadow: {
    card: {
      shadowColor: '#2B2118',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.07,
      shadowRadius: 16,
      elevation: 3,
    } satisfies ViewStyle,
  },
  layout: {
    screenPadding: 18,
    buttonHeight: 48,
    inputHeight: 48,
    iconSize: 42,
    progressHeight: 8,
    screenWidth: 375,
    screenHeight: 812,
    tabBarHeight: 66,
  },
  component: {
    button: {
      heightSm: 38,
      heightMd: 48,
      heightLg: 56,
      radius: 16,
      iconGap: 8,
    },
    card: {
      radius: 20,
      compactRadius: 14,
      padding: 16,
      compactPadding: 12,
    },
    badge: {
      height: 26,
      radius: 999,
      paddingHorizontal: 10,
    },
    iconButton: {
      size: 42,
      compactSize: 34,
      radius: 999,
    },
    segmentedControl: {
      height: 42,
      radius: 999,
      padding: 4,
    },
    studentShell: {
      maxWidth: 374,
      tabBarHeight: 64,
      tabBarRadius: 34,
      bottomOffset: 16,
    },
    photoSearchPreview: {
      minHeight: 330,
      mediaHeight: 286,
      radius: 24,
      controlHeight: 74,
    },
  },
} as const;

export type AppTokens = typeof tokens;
